export default [
  // {
  //   label: 'Início',
  //   to: '/'
  // },
  // {
  //   label: 'Diferenciais',
  //   to: '/diferenciais'
  // },
  // {
  //   label: 'Planos',
  //   to: '/planos'
  // }
]
